<template>
    <async-select
        v-model="checkbook"
        api     = "check_books"
        placeholder="Scheckbuch auswählen"
    />

</template>



<script>

import Multiselect from './Multiselect';
import {currentUser} from "@utilities/functions";
import {getSession, setSession} from "@utilities/session";
import {editUser} from "@api";
import {notifyError} from "@components/Notification";
import AsyncSelect from "@components/form/AsyncSelect";


export default {
    components: {AsyncSelect},
    props: {
        value:       {},
    },

    computed: {
        checkbook: {
            get: function () {
                return this.value;
            },
            set: function (checkBook) {
                this.updateCurrentOrganisation(checkBook);
            }
        },
    },

    methods: {
        updateCurrentOrganisation: function (checkBook) {
             const user = getSession();
                user.checkBook = checkBook;
                setSession(user);
                this.$emit('input', checkBook);
        }
    },
}
</script>
